export const types = {
    UPDATE_USER_INFO: 'UPDATE_USER_INFO',
}
